module.exports = __webpack_public_path__ + "static/img/1.79c58335.png";